import { render, staticRenderFns } from "./totalizer.vue?vue&type=template&id=0c10bb98&scoped=true&"
import script from "./totalizer.vue?vue&type=script&lang=js&"
export * from "./totalizer.vue?vue&type=script&lang=js&"
import style0 from "./totalizer.vue?vue&type=style&index=0&id=0c10bb98&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c10bb98",
  null
  
)

export default component.exports